import { render, staticRenderFns } from "./AdminAnnouncementsView.vue?vue&type=template&id=1160c91d"
import script from "./AdminAnnouncementsView.vue?vue&type=script&lang=ts"
export * from "./AdminAnnouncementsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports